import { ServiceBase } from '../../../../../core/services/ServiceBase'
import FinancialAnalysisProxy from './proxy'

class FinancialAnalysisService extends ServiceBase {
  getTemplates(params) {
    return this.getData(() => FinancialAnalysisProxy.getTemplates(params))
  }

  getTemplateDetail(params) {
    return this.getData(() => FinancialAnalysisProxy.getTemplateDetail(params))
  }

  setDefaultTemplate(params) {
    return this.getData(
      () => FinancialAnalysisProxy.setDefaultTemplate(params),
      true,
    )
  }

  deleteTemplates(params) {
    return this.getData(
      () => FinancialAnalysisProxy.deleteTemplates(params),
      true,
    )
  }

  updateTemplate(params) {
    return this.getData(
      () => FinancialAnalysisProxy.updateTemplate(params),
      true,
    )
  }

  saveTemplate(params) {
    return this.getData(() => FinancialAnalysisProxy.saveTemplate(params), true)
  }

  getDefaultTemplate(params) {
    return this.getData(() => FinancialAnalysisProxy.getDefaultTemplate(params))
  }

  getHighlight(params) {
    return this.getData(() => FinancialAnalysisProxy.getHighlight(params))
  }

  getProfitability(params) {
    return this.getData(() => FinancialAnalysisProxy.getProfitability(params))
  }

  downloadProfitability(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadProfitability(params),
    )
  }

  getQuickAssessmentCorporate(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getQuickAssessmentCorporate(params),
    )
  }

  downloadQuickAssessmentCorporate(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadQuickAssessmentCorporate(params),
    )
  }

  getRoaAndRoe(params) {
    return this.getData(() => FinancialAnalysisProxy.getRoaAndRoe(params))
  }

  downloadRoaAndRoe(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadRoaAndRoe(params),
    )
  }

  getAssetManagementEfficiency(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getAssetManagementEfficiency(params),
    )
  }

  downloadAssetManagementEfficiency(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadAssetManagementEfficiency(params),
    )
  }

  getBankQuickAssessment(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getBankQuickAssessment(params),
    )
  }

  downloadBankQuickAssessment(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadBankQuickAssessment(params),
    )
  }

  getNonBankQuickAssessment(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getNonBankQuickAssessment(params),
    )
  }

  downloadNonBankQuickAssessment(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadNonBankQuickAssessment(params),
    )
  }

  getCoverage(params) {
    return this.getData(() => FinancialAnalysisProxy.getCoverage(params))
  }

  downloadCoverage(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadCoverage(params),
    )
  }

  getSolvency(params) {
    return this.getData(() => FinancialAnalysisProxy.getSolvency(params))
  }

  downloadSolvency(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadSolvency(params),
    )
  }

  getLoanBookBreakdown(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getLoanBookBreakdown(params),
    )
  }

  downloadLoanBookBreakdown(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadLoanBookBreakdown(params),
    )
  }

  getDepositAndCredit(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getDepositAndCredit(params),
    )
  }

  downloadDepositAndCredit(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadDepositAndCredit(params),
    )
  }

  getAverageCost(params) {
    return this.getData(() => FinancialAnalysisProxy.getAverageCost(params))
  }

  downloadAverageCost(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadAverageCost(params),
    )
  }

  getCapitalAndLeverage(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getCapitalAndLeverage(params),
    )
  }

  downloadCapitalAndLeverage(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadCapitalAndLeverage(params),
    )
  }

  getLiquidity(params) {
    return this.getData(() => FinancialAnalysisProxy.getLiquidity(params))
  }

  downloadLiquidity(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadLiquidity(params),
    )
  }

  getFundingStructure(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getFundingStructure(params),
    )
  }

  downloadFundingStructure(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadFundingStructure(params),
    )
  }

  getEarningBreakdown(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getEarningBreakdown(params),
    )
  }

  downloadEarningBreakdown(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadEarningBreakdown(params),
    )
  }

  getBalanceBreakdown(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getBalanceBreakdown(params),
    )
  }

  downloadBalanceBreakdown(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadBalanceBreakdown(params),
    )
  }

  getCashBreakdown(params) {
    return this.getData(() => FinancialAnalysisProxy.getCashBreakdown(params))
  }

  downloadCashBreakdown(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadCashBreakdown(params),
    )
  }

  getOperatingIncome(params) {
    return this.getData(() => FinancialAnalysisProxy.getOperatingIncome(params))
  }

  downloadOperatingIncome(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadOperatingIncome(params),
    )
  }

  getBusinessPosition(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getBusinessPosition(params),
    )
  }

  downloadBusinessPosition(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadBusinessPosition(params),
    )
  }

  getFinancialAssets(params) {
    return this.getData(() => FinancialAnalysisProxy.getFinancialAssets(params))
  }

  downloadFinancialAssets(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadFinancialAssets(params),
    )
  }

  getEarningsQuality(params) {
    return this.getData(() => FinancialAnalysisProxy.getEarningsQuality(params))
  }

  downloadEarningsQuality(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadEarningsQuality(params),
    )
  }

  getLeverage(params) {
    return this.getData(() => FinancialAnalysisProxy.getLeverage(params))
  }

  downloadLeverage(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadLeverage(params),
    )
  }

  getFundingAndLiquidity(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getFundingAndLiquidity(params),
    )
  }

  downloadFundingAndLiquidity(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadFundingAndLiquidity(params),
    )
  }

  getInsurancePremiumRevenue(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getInsurancePremiumRevenue(params),
    )
  }

  downloadInsurancePremiumRevenue(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadInsurancePremiumRevenue(params),
    )
  }

  getInsuranceSolvency(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getInsuranceSolvency(params),
    )
  }

  downloadInsuranceSolvency(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadInsuranceSolvency(params),
    )
  }

  getOperationalEfficiency(params) {
    return this.getData(() =>
      FinancialAnalysisProxy.getOperationalEfficiency(params),
    )
  }

  downloadOperationalEfficiency(params) {
    return this.getFileDownload(() =>
      FinancialAnalysisProxy.downloadOperationalEfficiency(params),
    )
  }

  getIndicatorPanel(params) {
    return this.applyMemoryCache(
      'companyAnalysis/financial/financialAnalysis/getIndicatorPanel',
      params,
    )(() => FinancialAnalysisProxy.getIndicatorPanel(params))
  }
}

export default new FinancialAnalysisService()
